<template>
  <div class="menu-title flex items-center justify-between" :style="{fontSize: `${fSize}px`}">
    <div class="name flex items-center">
      <div v-if="showLine" class="line" />
      <slot></slot>
    </div>
    <menu-close-svg v-if="close" class="cursor-pointer" @click="close && close()" />
    <menu-switch v-if="showSwitch" style="margin-bottom: 0px;" :value="value"  label="" @change="e=>switchChange(e)"></menu-switch>
  </div>
</template>

<script>
import menuCloseSvg from '~/assets/svg/icon/menu-close.svg'
import MenuSwitch from "~/components/menu/menuSwitch";
export default {
  name: 'MenuTitle',
  components: {
    MenuSwitch,
    menuCloseSvg
  },
  model:{
    props: 'value',
    event: 'change'
  },
  props: {
    close: [Function],
    showSwitch: Boolean,
    // eslint-disable-next-line vue/require-prop-type-constructor
    value: Boolean | undefined,
    showLine: {
      type: Boolean,
      default: true
    },
    fSize: {
      type:Number,
      default: 18
    }
  },
  data() {
    return {
    }
  },
  created() {
  },
  methods: {
    switchChange(e){
      this.$emit('change',e)
    }
  }
}
</script>

<style lang="less">
.menu-title {
  color: rgba(255, 255, 255, 0.9);
  font-size: 16px;
  font-weight: 600;
  position: relative;
  margin-bottom: 20px;
  padding-bottom: 8px;
  border-bottom: 1px solid rgba(255, 255, 255, 0.06);
  
  .name {
    display: flex;
    align-items: center;
    letter-spacing: 0.5px;
  }

  .line {
    height: 16px;
    width: 4px;
    background-color: var(--primary-color);
    margin-right: 12px;
    border-radius: 2px;
    box-shadow: 0 0 8px rgba(var(--primary-color-rgb), 0.6);
  }

  // 关闭图标样式优化
  svg {
    opacity: 0.6;
    transition: all 0.3s ease;
    
    &:hover {
      opacity: 1;
      transform: scale(1.1);
      filter: drop-shadow(0 0 4px rgba(255, 255, 255, 0.5));
    }
  }
}
</style>
